// Samofund design foundations, inlined so this chat module is self-contained
// and can be dropped into BOTH apps (samofundmobile has src/theme/tokens.ts,
// samofundagency does not). Values mirror the design canvas exactly.
export const CT = {
  green: '#1E8C45',
  greenHover: '#177238',
  forest: '#0F4E27',
  greenTint: '#E7F4EC',
  pink: '#D6398A',
  pinkTint: '#FBE7F1',

  ink: '#16201A',
  inkSoft: '#3B453F',
  muted: '#6B7570',
  faint: '#9AA39E',
  border: '#E6EAE6',
  hairline: '#EFF2EE',
  bone: '#F6F8F4',
  bg: '#FBFAF7',
  white: '#FFFFFF',

  mono: "'JetBrains Mono', Menlo, Consolas, monospace",
  radius: { sm: 8, md: 10, lg: 14, xl: 18 },
  motion: 'all .16s cubic-bezier(.4,0,.2,1)',
  // Sits above MUI dialogs' backdrop but below modals the user opens from chat.
  z: 1250,
} as const;

/** Deterministic avatar tint so a person keeps the same colour everywhere. */
export function avatarTone(seed: string): { bg: string; fg: string } {
  const tones = [
    { bg: CT.greenTint, fg: CT.forest },
    { bg: CT.pinkTint, fg: '#9A2367' },
    { bg: '#E8EEF8', fg: '#1B3A63' },
    { bg: '#FDF1DC', fg: '#7A4E10' },
  ];
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return tones[hash % tones.length];
}

export function initialsOf(name: string): string {
  return (
    (name || '?')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join('')
      .toUpperCase() || '?'
  );
}

/** Compact, human timestamp for lists and bubbles. */
export function shortTime(iso: string): string {
  const then = new Date(iso);
  const now = new Date();
  const sameDay = then.toDateString() === now.toDateString();
  if (sameDay) return then.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (then.toDateString() === yesterday.toDateString()) return 'Yesterday';
  if (now.getTime() - then.getTime() < 7 * 86400000) {
    return then.toLocaleDateString([], { weekday: 'short' });
  }
  return then.toLocaleDateString([], { month: 'short', day: 'numeric' });
}
